import React from 'react';
import ReactDOM from 'react-dom/client';
import { CapacitorUpdater } from '@capgo/capacitor-updater';
import App from './App';

// Tell Capgo this bundle is healthy — prevents rollback, no dialog shown
CapacitorUpdater.notifyAppReady();


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
